<canvas #canvas class="nc-shape-grid-canvas" [style.background-color]="ncBgColor"></canvas>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>